import { createSlice } from '@reduxjs/toolkit';

import { getProductInventory, downloadInventoryDetails } from '../../apis';

export const LowInventoryDashboardSlice = createSlice({

    name: 'lowInventoryDashboardSlice',
    initialState: {
        isLoading: false,
        data: [],
        error: '',
        downloadInventoryDetailsSuccess: false,
    },

    reducers: {
        clear: (state, action) => {
            return {
              ...state,
              [action.payload.key]: action.payload.value,
            };
          },
    },

    extraReducers: (builder) => {
      builder.addCase(getProductInventory.pending, (state, action) => {
        state.isLoading = true;
    })
    builder.addCase(getProductInventory.fulfilled, (state, action) => {
        state.isLoading = true;
        state.error = '';
        state.data = action.payload.data
    })
    builder.addCase(getProductInventory.rejected, (state, action) => {
        state.error = action.payload.message
        state.isLoading = false;
    })
      builder.addCase(downloadInventoryDetails.pending, (state, action) => {
        state.isLoading = true;
    })
    builder.addCase(downloadInventoryDetails.fulfilled, (state, action) => {
        state.isLoading = true;
        state.error = '';
        state.downloadInventoryDetailsSuccess = true
    })
    builder.addCase(downloadInventoryDetails.rejected, (state, action) => {
        state.error = action.payload.message
        state.isLoading = false;
    })
      
    }
})

export const { clear } = LowInventoryDashboardSlice.actions

export default LowInventoryDashboardSlice.reducer